import React from "react";
import { Alert, Button } from "antd";
import { WifiOutlined, ReloadOutlined } from "@ant-design/icons";

interface NetworkStatusAlertProps {
  visible: boolean;
  loading?: boolean;
  onRetry?: () => void;
  onClose?: () => void;
  message?: string;
}

const NetworkStatusAlert: React.FC<NetworkStatusAlertProps> = ({
  visible,
  loading = false,
  onRetry,
  onClose,
  message = "Connection issue - showing saved data",
}) => {
  if (!visible) return null;

  return (
    <Alert
      message={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <WifiOutlined style={{ color: "#faad14" }} />
            <span>{message}</span>
          </div>
          {onRetry && (
            <Button
              size="small"
              type="link"
              icon={<ReloadOutlined />}
              onClick={onRetry}
              loading={loading}
            >
              Retry
            </Button>
          )}
        </div>
      }
      type="warning"
      showIcon={false}
      style={{
        margin: "8px 16px",
        borderRadius: "4px",
      }}
      closable
      onClose={onClose}
    />
  );
};

export default NetworkStatusAlert;
